"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceInfo = exports.Name = exports.name = exports.Code = exports.code = exports.NAMESPACE = void 0;
const effect_1 = require("effect");
exports.NAMESPACE = 'Culligan.Device.Vendor.Adt';
exports.code = 'adt';
exports.Code = effect_1.Schema.Literal(exports.code).annotations({
    identifier: `${exports.NAMESPACE}.Code`,
});
exports.name = 'Adt';
exports.Name = effect_1.Schema.Literal(exports.name).annotations({
    identifier: `${exports.NAMESPACE}.Name`,
});
class DeviceInfo extends effect_1.Schema.Class(`${exports.NAMESPACE}.DeviceInfo`)({
    code: effect_1.Schema.tag(exports.code),
}) {
    static label = exports.name;
}
exports.DeviceInfo = DeviceInfo;
//# sourceMappingURL=adt.js.map